<section>
    <fieldset class="rate">
        <ng-container *ngFor="let star of stars; let i=index" >
            <input type="radio" [ngClass]="{'star_checked': star.value <= currentValue}" [(ngModel)]="currentValue" [id]="'rating' + index" name="rating" [value]="star.value" />
            <label [ngClass]="{'half': star.half, 'displayOnly' : displayOnly}" [for]="'rating' + index" (click)="onChange(star.value)"></label>
        </ng-container>
    </fieldset>
    <span class="rate__value">{{currentValue}} of {{total}}</span>
</section>